<template>
  <div @contextmenu.prevent="" class="Top">
    <!-- 促销页 -->
    <div class="communications" v-if="Promotion">
      <div class="nextCont">
        <div class="substance">
          <Seckill
            @windowRightMenu="windowRightMenu"
            :content="rightFloat[Promotion]"
            :blockData="rightFloat[Promotion].seckill"
          />
        </div>
      </div>
    </div>
    <!-- 促销页 -->
    <div
      v-else
      :class="[
        'havrTransform',
        $store.state.pageFontSize ? $store.state.pageFontSize : '',
      ]"
    >
      <div @contextmenu.prevent="" class="head">
        <nav-top />
        <Header
          :flowShow="flowShow"
          :activeSubIndex="subActiveInd"
          @changeSubInd="changeSubInd"
          @windowRightMenu="windowRightMenu"
          @touchstart="touchstarts"
          @touchmove="touchmoves"
          @touchend="touchends"
        />
      </div>
      <div :class="['backImage',{'bannerImage':haveBanner}]">
        <template v-for="(blockData, ind) in blockList">
          <FloorBlock
            v-if="
              (tagData.indexOf(blockData.floorType) > -1 ||
                blockData.floorType == 'smartApp' ||
                blockData.floorType == 'companyIntroduce' ||
                blockData.floorType == 'flowArchShow' ||
                blockData.floorType == 'sceneArchMainShow' ||
                blockData.floorType == 'sceneArchSecondShow' ||
                blockData.floorType.indexOf('smartAppSameScreenShow') > -1 ||
                blockData.floorType == 'search' ||
                blockData.floorType == 'busbanner' ||
                blockData.floorType == 'banner' ||
                blockData.floorType == 'swindow' ||
                blockData.floorType == 'screenshow' ||
                blockData.floorType == 'sceneArchThirdShow') &&
              ind < 5 * num
            "
            :key="blockData.id"
            :indexs="ind"
            :rightShow="blockrightShow && flag"
            :blockData="blockData"
            @windowRightMenu="windowRightMenu"
          />
        </template>
      </div>

      <Footer />
    </div>
    <div
      class="right-menu"
      @mousedown.stop=""
      @touchstart.stop=""
      v-if="rightShow"
      :style="{ top: `${rMenuPos.top}px`, left: `${rMenuPos.left}px` }"
    >
      <el-cascader-panel
        @expand-change="handleExpandChange"
        :props="{
          expandTrigger: 'hover',
          label: 'menuName',
          value: 'childmenu',
          children: 'children',
        }"
        :options="rightContent"
      >
        <li
          slot-scope="{ data }"
          :class="data.childmenu"
          :title="data.menuName"
          @mousedown.stop="liNewHoverFun(data)"
          @mouseenter="liNewHoverFunEnter(data)"
        >
          <span>{{ data.menuName }}</span>
        </li>
      </el-cascader-panel>
    </div>
    <ul
      v-if="!Promotion"
      :class="[
        'Anchor',
        $store.state.pageFontSize ? $store.state.pageFontSize : '',
      ]"
      ref="Anchors"
      :style="{ right: AnchorRight + 'px' }"
    >
      <li>
        <div class="supFloat shop"></div>
        <i class="el-icon-shopping-cart-full"></i>购物车
      </li>
      <div class="line"></div>
      <li>
        <div class="supFloat kefu"></div>
        <i class="iconfont icon-kefu"></i>客服
      </li>
    </ul>
  </div>
</template>
<script>
import Bus from "../bus.js";
import Header from "../components/Header.vue";
import { menu, appendMenu, authLoginMenu } from "../menu.js";
import FloorBlock from "../components/floorBlock.vue";
import NavTop from "../components/NavTop.vue";
import Footer from "../components/Footer.vue";
import Seckill from "../components/seckill.vue";
export default {
  name: "Next",
  components: {
    Header,
    FloorBlock,
    Footer,
    NavTop,
    Seckill,
  },
  data() {
    return {
      Promotion: this.getQuery("promotionTypes"),
      minMax: true,
      window: window,
      seckill: false,
      member: false,
      seckills: { show: false },
      bady: document.getElementById("cme-footer"),
      num: window.location.origin.indexOf("localhost:3001") > -1 ? 100 : 1,
      rightType: this.$store.state.rightType,
      rightChangeNum: 1,
      timeOutEvent: 0,
      blockList: [],
      tagsName: [],
      tagsValue: [],
      flag: false,
      blockrightShow: false,
      rMenuPos: {
        left: 0,
        top: 0,
      },
      bannerList: [],
      introduceList: [],
      rightShow: false,
      flowShow: false,
      rightMenus: null,
      subActiveInd: -1,
      canAddCircle: false,
      canAdddliverProp: false,
      rightMenuArray: [],
      AnchorRightHeight: "",
      enName: "",
      rightFloat: [
        {
          name: "天天特惠",
          backImg: require("../assets/image/images/activity_bg_a.png"),
          Img: require("../assets/image/images/activity_shopping.png"),
          seckill: {
            floorType: "seckill",
            id: "scggfid1012379guru-flow-161494sdfa90675487",
          },
          ind: 1,
        },
        {
          name: "专享拼购",
          backImg: require("../assets/image/images/activity_bg_b.png"),
          Img: require("../assets/image/images/activity_shopping.png"),
          seckill: {
            floorType: "seckill",
            id: "scggfid1012379guru-flow-1614947sdfa90675487",
          },
          ind: 2,
        },
        {
          name: "换购特惠",
          backImg: require("../assets/image/images/activity_bg_b.png"),
          Img: require("../assets/image/images/activity_shopping.png"),
          seckill: {
            floorType: "seckill",
            id: "scggfid1012379guru-flow-161asdf47646190675487",
          },
          ind: 3,
        },
        {
          name: "用券专区",
          backImg: require("../assets/image/images/activity_bg_c.png"),
          Img: require("../assets/image/images/activity_coupon.png"),
          seckill: {
            floorType: "seckill",
            id: "scggfid1012379guru-flow-1614947asdf190675487",
          },
          ind: 4,
        },
        {
          name: "会员畅享",
          backImg: require("../assets/image/images/activity_bg_d.png"),
          Img: require("../assets/image/images/activity_member.png"),
          seckill: {
            floorType: "seckill",
            id: "scggfid1012379guru-flow-161dfs46190675487",
          },
          ind: 5,
        },
      ],
      rightFloatItem: {},
      //screenWidth: window.innerWidth//屏幕宽度
    };
  },
  computed: {
    showCurr() {
      return this.$store.state.showCurr;
    },
    AnchorRight() {
      var width = (this.$store.state.winWidth - 1200) / 2 - 86;
      if (window.innerWidth <= 1380) {
        width = 10;
      }
      return width;
    },
    tagData() {
      return this.$store.state.tagData;
    },
    flowType() {
      return this.$store.state.flowType;
    },
    rightContent() {
      return [
        "banner",
        "platform-show",
        "media-scene",
        "wisemen-say",
        "todays-news",
        "shake-horizon",
        "intelligent-broadcasting",
        "ai-equipment",
        "intelligent-library",
        "live-display",
        "media-broadcast",
        "product-streaming",
        "live-training",
        "talent-recruitment",
        "education-training",
        "member-alliance",
        "state-centric",
        "provinces-cities",
        "into-city",
        "county-window",
        "town-center",
        "village-center",
        "all-things",
        "enterprise-style",
        "member-style",
        "personal-honor",
        "gateway-block",
        "product-performance",
        "project-performance",
        "qualification-honor",
        "media-window",
        "library",
      ].includes(this.enName)
        ? this.rightMenus.filter((tag) => !(tag.menuName == "加入购物车" || tag.menuName == "小元文档"))
        : this.rightMenus.filter((tag) => !(tag.menuName == "小元文档"));
    },
    haveBanner() {
      console.log(this.blockList.filter(tag => tag.flowEnName == 'banner').length);
      
      return this.blockList.filter(tag => tag.flowEnName == 'banner').length;
    }
  },
  activated() {
    //被keepalive包裹才会触发
    document.documentElement.scrollTop = this.$route.meta.scrollTop || 0;
  },
  updated() {
    this.bady = document.getElementById("cme-footer");
  },
  provide() {
    return {
      seckill: this.seckills,
      member: this.members,
    };
  },
  mounted() {
    window.$kefuCurr = false;
    //客户端交互使用
    window.$show = this;
    const _this = this;
    _this.Drags(".Anchor");
    // document.getElementById('app').removeAttribute('style');
    // document.querySelector('body').style.cssText = 'overflow:hidden';
    if (_this.getQuery("qrcodeType")) {
      _this.qrcodeCount();
    }
    _this.initRightMenu({
      types: _this.rightType,
      appId: "zjsqe",
      frameType: "show",
      permitUserId: _this.$store.state.userInfo.userId
        ? _this.$store.state.userInfo.userId
        : "",
      blockId: "sdfasdf",
    });
    $(window).scroll(() => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const distance = 500;
      if (scrollHeight - scrollTop - clientHeight < distance) {
        _this.num++;
      }
      if (
        document.getElementById("app").style.transform &&
        $(".Anchor").length
      ) {
        var t = document.documentElement.scrollTop || document.body.scrollTop;
        var scale = document.getElementById("app").style.transform.slice(6, -1);
        var visibleTop = t / scale;
        $(".Anchor").css(
          "bottom",
          window.$bottom -
            (visibleTop - (window.$scrollTop ? window.$scrollTop : 0)),
        );
      }
    });
    // _this.getRightFloat();
    _this.getBlockAll();
    window.addEventListener("mousedown", (event) => {
      if (event.button == 0) {
        _this.rightShow = false;
        _this.flowShow = false;
        _this.blockrightShow = false;
        _this.subActiveInd = -1;
      } else if (event.button == 2) {
        window.$rightLeft.center = {};
      }
    });
    window.addEventListener("touchstart", (event) => {
      _this.rightShow = false;
      _this.flowShow = false;
      _this.blockrightShow = false;
      _this.subActiveInd = -1;
    });

    Bus.$on("sendCircleType", (params) => {
      _this.canAdddliverProp = params.dliverProp;
      _this.canAddCircle = params.circle;
    });
    Bus.$on("iframeOpen", (t, i) => {
      _this.iframeOpen(t, i);
    });
    Bus.$on("windowRight", (t, item, enName) => {
      _this.enName = enName;
      if (_this.$route.name == "Next") {
        //登录后的右键
        if (_this.rightType != 531) {
          //流程块右键
          if (
            item &&
            (item.hasQuote != undefined ||
              item.flowType == "block" ||
              item.blockId ||
              item.nodeId)
          ) {
            _this.rightMenus = [{ menuName: "正在加载......" }];
            _this.initRightMenus({
              types: _this.rightType,
              blockId: window.$nodeId ? window.$nodeId : "",
              frameType: "show",
              permitUserId: _this.$store.state.userInfo.userId,
            });
            //流程右键
          } else if (item && item.appId != undefined) {
            _this.rightMenus = [{ menuName: "正在加载......" }];
            _this.initRightMenu({
              types: _this.rightType,
              appId: item.appId,
              frameType: "show",
              flowId: item.id ? item.id : "",
              permitUserId: _this.$store.state.userInfo.userId,
            });
          }
          //banner层、简介层右键
          if ((item && item == "block") || !t) {
            _this.rightMenus = [{ menuName: "正在加载......" }];
            _this.initRightMenus({
              types: _this.rightType,
              blockId: window.$nodeId ? window.$nodeId : "",
              frameType: "show",
              permitUserId: _this.$store.state.userInfo.userId,
            });
          }
          //货架左侧列表右键
          if (item && item == "floor") {
            _this.rightMenus = [{ menuName: "正在加载......" }];
            _this.initRightMenu({
              types: _this.rightType,
              appId: "cpsxzspzpt",
              frameType: "show",
              flowId:
                "scgid1012380guru-flow-1614947657055181999-quote-cpsxzspzpt",
              permitUserId: _this.$store.state.userInfo.userId,
            });
          }
        }
        //阻止外层右键事件后重新触发
        if (t) {
          _this.windowRightMenu(t, "floor");
        }
      }
    });
  },
  watch: {
    // rightShow: function (val) {
    //   if (!val) {
    //     window.$rightLeft.center = {};
    //   }
    // }
  },
  methods: {
    getRightFloat() {
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/getWzDuctionTypeByAppId.json",
          {
            appId: this.$appId,
          },
        )
        .then((resq) => {
          if (resq.state == 1 && resq.data) {
            var array = [],
              arr = resq.data;
            if (arr.indexOf("1") > -1) {
              array.push({
                name: "天天特惠",
                backImg: require("../assets/image/images/activity_bg_a.png"),
                Img: require("../assets/image/images/activity_shopping.png"),
                seckill: {
                  floorType: "seckill",
                  id: "scggfid1012379guru-flow-161494sdfa90675487",
                },
                ind: 1,
              });
            }
            if (arr.indexOf("2") > -1) {
              array.push({
                name: "专享拼购",
                backImg: require("../assets/image/images/activity_bg_b.png"),
                Img: require("../assets/image/images/activity_shopping.png"),
                seckill: {
                  floorType: "seckill",
                  id: "scggfid1012379guru-flow-1614947sdfa90675487",
                },
                ind: 2,
              });
            }
            if (arr.indexOf("3") > -1) {
              array.push({
                name: "换购特惠",
                backImg: require("../assets/image/images/activity_bg_b.png"),
                Img: require("../assets/image/images/activity_shopping.png"),
                seckill: {
                  floorType: "seckill",
                  id: "scggfid1012379guru-flow-161asdf47646190675487",
                },
                ind: 3,
              });
            }
            if (arr.indexOf("4") > -1) {
              array.push({
                name: "用券专区",
                backImg: require("../assets/image/images/activity_bg_c.png"),
                Img: require("../assets/image/images/activity_coupon.png"),
                seckill: {
                  floorType: "seckill",
                  id: "scggfid1012379guru-flow-1614947asdf190675487",
                },
                ind: 4,
              });
            }
            if (
              arr.indexOf("5") > -1 &&
              this.$store.state.memberLevel &&
              this.getMemberLevel(this.$store.state.memberLevel).memberLevel
            ) {
              array.push({
                name: "会员畅享",
                backImg: require("../assets/image/images/activity_bg_d.png"),
                Img: require("../assets/image/images/activity_member.png"),
                seckill: {
                  floorType: "seckill",
                  id: "scggfid1012379guru-flow-161dfs46190675487",
                },
                ind: 5,
              });
            }
            this.rightFloat = array;
          }
          // this.$nextTick(()=>{
          //   this.AnchorRightHeight = window.innerHeight / 2 - this.$refs.Anchors.clientHeight / 2;
          // })
        });
    },
    closeLayer() {
      this.seckills.show = false;
      document.querySelector("body").removeAttribute("style");
      Bus.$emit("reScring");
      this.rightShow = false;
    },
    seckillChange(val) {
      if (val) {
        this.seckills.show = true;
        this.rightFloatItem = val;
        document.getElementById("app").removeAttribute("style");
        document.querySelector("body").style.cssText = "overflow:hidden";
      } else {
        // var appId = this.$appId,
        // address = window.location.pathname.split('/')[1] ? window.location.pathname.split('/')[1] : 'uoqid',content;

        // content = `${window.location.origin}${(window.location.pathname.indexOf('shopCart') > 0 ? window.location.pathname : '/' + address + '/shopCart')}?appId=${appId}`;

        layer.open({
          type: 2,
          title: "购物车",
          area: ["100%", "100%"],
          content:
            window.location.origin + "/oqmid-pay-tool-web/shop/cart/list",
        });
      }
    },
    // 统计二维码扫码量
    qrcodeCount() {
      this.$http
        .get("/acnid-project-approve/api/process/qrcode/record/save.json", {
          qrcodeType: "wz",
          dataId: this.getQuery("appId"),
          codeScanner: this.getQuery("toUserId"),
          behavior: "scan",
        })
        .then((res) => {
          if (res.state == 1) {
            console.log("===");
          }
        });
    },
    isPC() {
      if (window.innerWidth > 768) {
        return true;
      } else {
        return false;
      }
    },
    liNewHoverFunEnter(data) {
      if (!this.IsMobile()) {
        this.changeData(data);
      }
    },
    handleExpandChange(data) {
      this.rightAreaChange(data, this.rMenuPos.left);
    },
    touchstarts(ev, type) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        window.$rightLeft.center = {};
        _this.windowRightMenu(ev, type);
      }, 400);
      // 长按400毫秒
      // e.preventDefault();
    },
    touchmoves() {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends(e) {
      clearTimeout(this.timeOutEvent);
      if (this.timeOutEvent != 0) {
        // 点击事件
        // this.rightShow = false;
      }
      return false;
    },
    changeSubInd(ind) {
      this.subActiveInd = ind;
    },
    //流程右键
    initRightMenu(data) {
      var _this = this;
      if (data.flowId && sessionStorage.getItem(data.types + data.flowId)) {
        _this.rightMenus = JSON.parse(
          sessionStorage.getItem(data.types + data.flowId),
        );
      } else {
        _this.$http
          .get("/zciid-deliverable/activity/appbutton/getlist.json", data)
          .then((res) => {
            if (res.state == 1 && res.data) {
              var datas = res.data;
              //会议助理同时添加开启直播
              var assistUserId = [];
              if (
                _this.$store.state.assistUserId &&
                _this.$store.state.assistUserId.length
              ) {
                _this.$store.state.assistUserId.forEach((ele, ind) => {
                  assistUserId.push(ele.userId);
                });
              }
              //在右键操作工具里添加开启直播
              // if (_this.$store.state.creatUserId == _this.$store.state.userInfo.userId || assistUserId.indexOf(_this.$store.state.userInfo.userId) > -1) {
              //   datas.unshift(...authLoginMenu);
              // }
              _this.$store.commit("setRightMenu", {
                menu: datas,
                append: "",
                type: data.type,
              });
              _this.rightMenus = _this.$store.state.rightMenu;
            } else {
              _this.rightMenus = appendMenu;
            }
          });
      }
    },
    //流程块右键，链接有变化
    initRightMenus(data) {
      var _this = this;
      if (data.blockId && sessionStorage.getItem(data.types + data.blockId)) {
        _this.rightMenus = JSON.parse(
          sessionStorage.getItem(data.types + data.blockId),
        );
      } else {
        _this.$http
          .get("/zciid-deliverable/activity/blockbutton/getlist.json", data)
          .then((res) => {
            if (res.state == 1 && res.data) {
              var datas = res.data;
              var assistUserId = [];
              if (
                _this.$store.state.assistUserId &&
                _this.$store.state.assistUserId.length
              ) {
                _this.$store.state.assistUserId.forEach((ele, ind) => {
                  assistUserId.push(ele.userId);
                });
              }
              //在右键操作工具里添加开启直播
              // if (_this.$store.state.creatUserId == _this.$store.state.userInfo.userId || assistUserId.indexOf(_this.$store.state.userInfo.userId) > -1) {
              //   datas.unshift(...authLoginMenu);
              // }
              _this.$store.commit("setRightMenu", {
                menu: datas,
                append: "",
                type: data.type,
              });
              _this.rightMenus = _this.$store.state.rightMenu;
              //公共方法
              _this.rightData(data, _this.$store.state.rightMenu);
            } else {
              _this.rightMenus = appendMenu;
            }
          });
      }
    },
    liNewHoverFun(item) {
      this.liNewHoverPublic(item, this);
    },

    clearMainNavChecked(t) {
      if (this.$store.state.isManage === 2) {
        this.$notify({
          position: "top-right",
          title: "提示",
          message: "平台创建人才可执行此操作",
          type: "warning",
          offset: wH,
        });
        return false;
      }
      var wH = window.innerHeight / 2 - 100;
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/post/delTAppFlowData.json",
          {
            appId: this.$appId,
            types: t,
          },
        )
        .then((res) => {
          if (res.state == 1) {
            this.$notify({
              position: "top-right",
              title: "提示",
              message: "清除成功",
              type: "warning",
              offset: wH,
            });
          } else {
            this.$notify({
              position: "top-right",
              title: "提示",
              message: "清除失败",
              type: "warning",
              offset: wH,
            });
          }
        });
    },
    setOrCancelSwiper(item) {
      var flag =
        item.childmenu == "huanyuanlunbopeizhi" ||
        item.childmenu == "lunbopeizhi";
      if (!flag) {
        return;
      }
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/updateShowFlowPosition.json",
          {
            appId: this.$appId,
            flowId: window.$floorflowId.id,
            flowOrDetail: "floor-slideshow",
            value: item.childmenu == "lunbopeizhi" ? "on" : "off",
          },
        )
        .then((res) => {
          if (res.state == 1) {
            window.location.reload();
          }
        });
    },
    // //打开layer弹窗
    // openLayerWin (url, tit) {
    //   var _this = this;
    //   layer.open({
    //     type: 2,
    //     title: tit,
    //     shadeClose: true,
    //     area: ['900px', '500px'],
    //     end: function () {
    //       //关闭获取是否更改
    //       // _this.$http
    //       //   .get("/zciid-deliverable/showPlatformStyle/flow/api/getTappFlowFloorType").then(res => {
    //       //   if (res.data == 1) {
    //       //       window.location.reload();
    //       //       更改后将data重置为0
    //       //       _this.$http
    //       //       .get("/zciid-deliverable/showPlatformStyle/flow/api/updateTappFlowFloorType").then(res => {})
    //       //   }
    //       // })
    //       window.location.reload();

    //     },
    //     maxmin: true,
    //     content: url, //iframe的url
    //     // success: function (layero, index) {
    //     //   layero[0].childNodes[2].childNodes[0].firstChild.style.background = 'white';
    //     //   layero[0].childNodes[2].childNodes[1].style.backgroundImage = "url(" + require("../assets/icon.png") + ")";
    //     //   layero[0].childNodes[2].childNodes[1].style.backgroundRepeat = "no-repeat";
    //     // }
    //   })
    // },
    //数据展示
    dataRightMenuShow(item) {
      if (item && item.childmenu == "tagdatashow") {
        //获取标签以及数据
        if (this.rMenuPos.top <= 140 && this.rMenuPos.top >= 110) {
          this.flowShow = true;
          this.rightShow = false;
        } else {
          this.blockrightShow = true;
          // this.flowShow=true;
        }
      }
    },
    //预览外展
    previewTargetSite(item, wH) {
      if (item.childmenu == "yulanwaizhan") {
        //预览外展
        if (window.$appId != ":javascript;") {
          let newAppUrl = `http://520emv.com/uoqid/?appId=${window.$appId}`;
          this.open(newAppUrl, "_blank", "预览");
        } else {
          this.$notify({
            position: "top-right",
            title: "提示",
            message: "该流程暂无外展平台",
            type: "warning",
            offset: wH,
          });
        }
      }
    },
    //设置或者取消上方默认流程
    setOrCancelFlow(item) {
      var flag =
        item.menuName == "取消上端默认流程" ||
        item.menuName == "还原上端默认流程";
      if (!flag) {
        return;
      }
      //还原上端默认流程
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/updateShowFlowPosition.json",
          {
            appId: this.$appId,
            flowId: window.$floorflowId.id,
            flowOrDetail: "flow-slideshow",
            value: item.menuName == "还原上端默认流程" ? "on" : "off",
          },
        )
        .then((res) => {
          if (res.state == 1) {
            window.location.reload();
          }
        });
    },
    //左移右移
    moveLeftOrRight(item) {
      var itemValue = item.childmenu;
      if (
        (window.$rightLeft && itemValue == "leftMove02") ||
        (window.$rightLeft && itemValue == "rightMove02")
      ) {
        const { left, center, right } = window.$rightLeft;
        if (
          !center.contentId ||
          (!center.contentShowRowsSort && !center.contentShowRowsSort == 0)
        ) {
          this.rightShow = false;
          return false;
        }
        var leftContentId = center.contentId;
        var leftSortNum = center.contentShowRowsSort;
        var rightContentId, rightSortNum;
        if (itemValue == "leftMove02") {
          if (!left.contentId || !left.contentShowRowsSort) {
            this.rightShow = false;
            return false;
          }
          if (!left.blockId || !center.blockId) {
            return false;
          }
          rightContentId = left.contentId;
          rightSortNum = left.contentShowRowsSort;
        }

        if (itemValue == "rightMove02") {
          if (!right.contentId || !right.contentShowRowsSort) {
            this.rightShow = false;
            return false;
          }
          if (
            !right.blockId ||
            !center.blockId ||
            center.blockId != right.blockId
          ) {
            return false;
          }
          rightContentId = right.contentId;
          rightSortNum = right.contentShowRowsSort;
        }

        this.$http
          .get(item.redirectUrl, {
            leftContentId,
            leftSortNum,
            rightContentId,
            rightSortNum,
          })
          .then((res) => {
            if (res.state == 1) {
              window.location.reload();
            }
          });
      }
    },
    //右键显示菜单
    // handleContMenu (item) {
    //   if (item.flowType == 'flow') {
    //     window.$flowId = item.id;
    //   }
    //   this.tagsValue = item.tagsValue;
    //   this.tagsName = item.tagsName
    //   this.blockrightShow = false;
    //   const ev = window.event;
    //   ev.stoppropagation;
    //   if ((ev.pageX + 290) > window.innerWidth) {
    //     this.rMenuPos.left = window.innerWidth - 290;
    //   } else {
    //     this.rMenuPos.left = ev.pageX;
    //   }
    //   this.rMenuPos.top = ev.pageY;
    //   this.flag = true;
    //   this.rightShow = true;
    // },
    //开启直播
    initLiveRoom(item) {
      if (item && item.childmenu == "openFloorLive") {
        this.open(
          `https://openvidu.520emv.com/#/${this.$store.state.userInfo.userId}/live/anchor?userNickName=${this.$store.state.userInfo.nickName}`,
          "_blank",
          "直播",
        );
      }
    },
    addToCart(item) {
      if (
        item &&
        (item.childmenu == "addToCart" || item.childmenu == "addToCart2") &&
        window.$rightLeft.center &&
        window.$rightLeft.center.standardJson
      ) {
        let productId = window.$rightLeft.center.contentId;
        this.joinShopCart(productId, window.$rightLeft.center.standardJson);
      }
    },
    //加入购物车 所需参数拼接
    joinShopCart(pId, allTagsJson) {
      this.messages = [];
      this.requiredMsgs = [];
      //产品名称
      var chanpinmingchen = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "appName",
      ).length
        ? allTagsJson.filter(
            (tags) => tags.standardEnName && tags.standardEnName == "appName",
          )[0].standardData
        : this.getStandardData(
            [
              "名称",
              "资产名称",
              "组织名称",
              "企业名称",
              "个人名称",
              "产品名称",
              "图片名称",
            ],
            "required",
            "",
            allTagsJson,
          );
      //产品图片
      var chanpintupian = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "mainFigure",
      ).length
        ? allTagsJson.filter(
            (tags) =>
              tags.standardEnName && tags.standardEnName == "mainFigure",
          )[0].standardData
        : allTagsJson.filter(
            (tags) => tags.fileTypeDetail == 2 && tags.standardData,
          )[0].standardData;
      //单价
      var price = allTagsJson.filter(
        (tags) =>
          tags.standardData &&
          (tags.standardEnName == "cpyxprice" ||
            tags.standardEnName == "xmjcprice" ||
            tags.standardEnName == "basicPrice"),
      );
      var danjia = price.length
        ? price
          ? price[0].standardData
          : ""
        : this.getStandardData(
            [
              "",
              "基础价格",
              "产品基础标签",
              "产品价格",
              "价格",
              "基准价",
              "金额",
            ],
            "number",
            "",
            allTagsJson,
          );
      //数量
      var shuliang = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "number",
      ).length
        ? allTagsJson.filter(
            (tags) => tags.standardEnName && tags.standardEnName == "number",
          )[0].standardData
        : this.getStandardData("数量", "number", "1", allTagsJson);
      //用户ID
      var userId = this.$store.state.userInfo.userId
        ? this.$store.state.userInfo.userId
        : "";
      //产品标识
      var productId = allTagsJson.filter(
        (tags) =>
          tags.standardEnName && tags.standardEnName == "productMarking",
      ).length
        ? allTagsJson.filter(
            (tags) =>
              tags.standardEnName && tags.standardEnName == "productMarking",
          )[0].standardData
        : "";
      //资产交易价
      var assetsPrice = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "assetsPrice",
      ).length
        ? allTagsJson.filter(
            (tags) =>
              tags.standardEnName && tags.standardEnName == "assetsPrice",
          )[0].standardData
        : "";
      //资产单位
      var assetsUnit = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "assetsUnit",
      ).length
        ? allTagsJson.filter(
            (tags) =>
              tags.standardEnName && tags.standardEnName == "assetsUnit",
          )[0].standardData
        : "";
      //租赁交易价
      var periodicPrice = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "periodicPrice",
      ).length
        ? allTagsJson.filter(
            (tags) =>
              tags.standardEnName && tags.standardEnName == "periodicPrice",
          )[0].standardData
        : "";
      //租赁单位
      var periodicUnit = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "periodicUnit",
      ).length
        ? allTagsJson.filter(
            (tags) =>
              tags.standardEnName && tags.standardEnName == "periodicUnit",
          )[0].standardData
        : "";
      //次数租赁价
      var timesPrice = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "timesPrice",
      ).length
        ? allTagsJson.filter(
            (tags) =>
              tags.standardEnName && tags.standardEnName == "timesPrice",
          )[0].standardData
        : "";
      //次数租赁单位
      var timesUnit = allTagsJson.filter(
        (tags) => tags.standardEnName && tags.standardEnName == "timesUnit",
      ).length
        ? allTagsJson.filter(
            (tags) => tags.standardEnName && tags.standardEnName == "timesUnit",
          )[0].standardData
        : "";

      if (
        (this.requiredMsgs.length > 0 || !chanpintupian || !danjia) &&
        !assetsPrice &&
        !periodicPrice
      ) {
        this.$notify({
          title: "提示",
          message: `(产品名称或图片名称、产品图片、单价)为必填选项，请去补充标签，并生成，再进行此操作`,
          type: "warning",
          duration: 5000,
        });
        return;
      }

      if (this.messages.length > 0) {
        this.$notify({
          title: "提示",
          message: `${this.messages.join("、")}，的值不是数字类型，请输入阿拉伯数字`,
          type: "warning",
          duration: 5000,
        });
        return;
      }
      if (danjia == "面议") {
        this.$notify({
          title: "提示",
          message: "此产品不支持加入购物车",
          type: "warning",
          duration: 5000,
        });
        return;
      }

      //数据资产类型
      var arrs = [
        "data-asset",
        "organizational-assets",
        "platform-assets",
        "special-asset",
        "window-asset",
      ];

      if (!productId && !arrs.includes(window.$floorflowId.flowEnName)) {
        this.$notify({
          title: "提示",
          message: "该产品暂不能购买",
          type: "warning",
        });
        return;
      }

      var productInfo = window.$rightLeft.center.item;

      var cart = {
        productName: chanpinmingchen,
        productImg: chanpintupian,
        prices:
          this.$store.state.memberLevel &&
          productInfo[
            this.getMemberLevel(this.$store.state.memberLevel).memberLevel
          ] &&
          productInfo.memberEndTime
            ? productInfo[
                this.getMemberLevel(this.$store.state.memberLevel).memberLevel
              ]
            : assetsPrice
              ? assetsPrice
              : periodicPrice
                ? periodicPrice
                : productInfo.discountTypes == "seckill"
                  ? productInfo.priceType
                  : danjia,
        activityType:
          this.$store.state.memberLevel &&
          productInfo[
            this.getMemberLevel(this.$store.state.memberLevel).memberLevel
          ] &&
          productInfo.memberEndTime
            ? "blankVip"
            : productInfo.discountTypes
              ? productInfo.discountTypes
              : "",
        activityEndTime: productInfo.endTime,
        buyNumber: shuliang,
        userId: userId ? userId : "",
        codes: userId
          ? ""
          : this.getQuery("localUserId")
            ? this.getQuery("localUserId")
            : localStorage.getItem("wxud"),
        productId: arrs.includes(window.$floorflowId.flowEnName)
          ? "asset-" + pId
          : productId
            ? productId + "-" + pId
            : pId,
        wzAppId: productInfo.appId ? productInfo.appId : "",
        units: assetsPrice ? assetsUnit : periodicPrice ? periodicUnit : "个",
        dataType: assetsPrice ? 1 : periodicPrice ? 2 : 0,
        merchantId: window.$rightLeft.center.item.appId,
        merchantName: window.$rightLeft.center.item.appName,
        payPfId:window.$rightLeft.center.item.pfId ? window.$rightLeft.center.item.pfId : '',
        
        detailsUrl:location.origin + '/uoqid?appId='+ productInfo.appId +'&blockId='+ productInfo.blockId +'&contentId='+ productInfo.contentId +'&dataType=' + (productInfo.sign ?  productInfo.sign : 1),
        // detailsUrl: "",
        pfId: window.$pfId ? window.$pfId : "",
        types: (window.$rightLeft.center.item.pfId ? window.$rightLeft.center.item.pfId : '') == (window.$pfId ? window.$pfId : '') ? 1 : 2
      };
      if (assetsPrice && periodicPrice) {
        window.$chooseToCart = true;
        this.chooseToCart(
          assetsPrice,
          assetsUnit,
          periodicPrice,
          periodicUnit,
          JSON.stringify(cart).replace(/"/g, "&quot;"),
          "",
          "",
          timesPrice,
          timesUnit,
        );
        return;
      } else {
        window.$chooseToCart = false;
      }
      this.$http
        .post(
          "/oqmid-pay-tool-web/shop/cart/save",
          { arrs: JSON.stringify(cart) },
          "a",
        )
        .then((res) => {
          if (res.state == 1) {
            const h = this.$createElement;
            this.$notify({
              title: "提示",
              dangerouslyUseHTMLString: true,
              type: "success",
              duration: 3000,
              message: h("div", { class: "personnel" }, [
                h("p", { class: "isCreate" }, "加入购物车成功！"),
                h(
                  "button",
                  {
                    class: "personnel-btn",
                    on: {
                      click: this.toOpen,
                    },
                  },
                  "购物车",
                ),
              ]),
            });
          } else {
            this.$notify({
              title: "提示",
              message: `该产品暂不支持购买`,
              type: "warning",
              duration: 5000,
            });
          }
        });
    },
    toOpen() {
      this.$notify.closeAll();
      this.handleShopCart()
      // var appId = this.$appId;
      // var address = window.location.pathname.split("/")[1]
      //   ? window.location.pathname.split("/")[1]
      //   : "uoqid";
      // var url = `${window.location.origin}${window.location.pathname.indexOf("shopCart") > 0 ? window.location.pathname : "/" + address + "/shopCart"}?shopId=${appId}`;
      // this.open(url, "_blank", "购物车");
    },
    //标签取值方法
    getStandardData(nameArr, type, nameData, allTagsJson) {
      const allTagsStandArr = allTagsJson;
      const sNames = typeof nameArr == "string" ? [nameArr] : nameArr;
      var filterStandArr = allTagsStandArr.filter(
        (ite) => sNames.indexOf(ite.standardName) > -1,
      );
      var filterData = filterStandArr[0]
        ? filterStandArr[0].standardData
        : nameData;
      var message = "";
      var requiredMsg = "";
      switch (type) {
        case "required":
          if (!filterData) {
            requiredMsg = `${sNames[0]}`;
          }
          break;
        case "number":
          if (isNaN(filterData)) {
            message = `${sNames[0]}`;
          }
          break;
      }
      if (requiredMsg) {
        this.requiredMsgs.push(requiredMsg);
      }
      if (message) {
        this.messages.push(message);
      }
      return filterData;
    },
    windowRightMenu(ev, type, enName) {
      this.rightShow = false;
      window.rightMenuArray = [];
      this.rMenuPos = this.calculateLocation(ev);
      this.flowShow = false;
      this.blockrightShow = false;
      this.flag = false;
      setTimeout(() => {
        this.rightShow = true;
      }, 1);
      // 导航右键
      if (type != "header") {
        this.subActiveInd = -1;
      } else if (this.rightType != 531) {
        this.rightMenus = [{ menuName: "正在加载......" }];
        this.initRightMenu({
          types: this.rightType,
          appId: "orgic",
          frameType: "show",
          flowId: "wzzid1000938guru-flow-1604056951561184764-quote-zjsqe",
          permitUserId: this.$store.state.userInfo.userId,
        });
      }
      Bus.$emit("banner", "");
    },
    //获取流程
    getBlockAll() {
      var _this = this;
      _this.introduceList = [];
      _this.bannerList = [];
      _this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json",
          {
            appId: _this.$appId,
            diyPageFlowCode: _this.$route.query.code,
            domainNameType: document.location.pathname.split("/")[1],
          },
          "getBlockAll",
        )
        .then((res) => {
          if (res.state == 1) {
            var banner = [],
              other = [];
            function action(flow) {
              return new Promise((resolve, reject) => {
                var flowId,
                  blockId,
                  nodeId,
                  appId,
                  sceneId = "";
                flowId = flow.id;
                if (
                  flow.dataArr.length &&
                  flow.dataArr[0].flowType == "block"
                ) {
                  blockId = flow.dataArr[0].id;
                  nodeId = flow.dataArr[0].nodeId;
                  appId = flow.appId;
                  sceneId = _this.$route.query.sceneId || "";
                }
                _this.$http
                  .get(
                    "/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json",
                    {
                      appId: _this.$appId,
                      flowId: flowId,
                      sceneId: sceneId,
                      nodeId: nodeId,
                      blockId: blockId,
                      bannerQyjj: "1",
                    },
                    "getBanner",
                  )
                  .then((req) => {
                    banner.push({
                      floorType: flow.floorType,
                      flowEnName: flow.flowEnName,
                      id: flowId,
                      appId: _this.$appId,
                      blockId: blockId,
                      nodeId: nodeId,
                      dataArr: [
                        {
                          contentArr: req.data,
                        },
                      ],
                    });
                    resolve();
                  });
              });
            }
            async function test() {
              //等待筛选出bannner层并且添加到数组
              for (let i = 0; i < res.data.length; i++) {
                if (
                  res.data[i].floorType == "banner" ||
                  res.data[i].floorType == "busbanner"
                ) {
                  await action(res.data[i]);
                } else {
                  other.push(res.data[i]);
                }
              }
              _this.blockList = _this.blockList.concat(banner.concat(other));
              _this.blockList.splice(1, 0, { floorType: "sceneArchThirdShow" });
              // _this.blockList.splice(2, 0, { floorType: 'Client' });
              //客户端预览页点击跳转到对应楼层
              const md = _this.getQuery("md");
              if (md) {
                var ind = _this.blockList.findIndex(
                  (tag) => tag.flowEnName && tag.flowEnName == md,
                );
                if (ind > 0) {
                  _this.num = parseInt(ind / 5) + 1;
                  _this.$nextTick(() => {
                    setTimeout(() => {
                      // document.querySelector(".m_title[enname="+ md +"]").scrollIntoView( {behavior:"smooth" });
                      var top = document.querySelector(
                        ".m_title[enname=" + md + "]",
                      ).offsetTop;
                      document.documentElement.scrollTop = top;
                    }, 1500);
                  });
                }
              }
            }
            test();
          } else {
            _this.blockList.splice(1, 0, { floorType: "sceneArchThirdShow" });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/css/txtImg.scss";
@import "../assets/css/home.css";
/* layerOpen弹出框样式开始 */
.communications {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #fff;
  z-index: 1999;
  overflow: hidden;
  box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
}
.nextCont {
  height: 100%;
  overflow: auto;
}
.substance {
  width: 1200px;
  margin: 0 auto;
  overflow: auto;
}
@media screen and (max-width: 1200px) {
  .substance {
    width: 100%;
    margin: 0 auto;
  }
}
.communications .layer-title {
  width: 100%;
  height: 42px;
  line-height: 42px;
  color: #fff;
  background-color: #4398dd;
  cursor: all-scroll;
}
.communications .layer-title .title {
  font-size: 14px;
  padding-left: 20px;
}
.communications .layui-layer-setwin {
  top: 14px;
}
.Anchor {
  position: fixed;
  bottom: calc(50% - 58px);
  box-shadow: 0px 0px 10px 0px rgba(7, 7, 7, 0.16);
  z-index: 1999;
  background-color: #fff;
  .line {
    width: 90%;
    margin: 0 auto;
    border-top: 1px dashed #aaa7a7;
  }
  > li {
    width: 58px;
    text-align: center;
    position: relative;
    font-size: 14px;
    cursor: pointer;
  }
  // >.supFloat:hover+li{
  //   background-color:#ff534a;
  //   color:#fff;
  // }
  > li {
    height: 47px;
    padding-top: 11px;

    i {
      display: block;
    }
    .el-icon-shopping-cart-full {
      font-size: 18px;
    }
  }
  li.curr {
    background-color: #4c9dfb;
    color: #fff;
  }
  li:hover {
    background-color: #4c9dfb;
    color: #fff;
  }
  .promotionProducts {
    position: absolute;
    top: 0;
    left: -136px;
    width: 130px;
    min-height: 72px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(7, 7, 7, 0.16);
    // border: 1px solid #e4e4e4;
    padding: 10px 0;
    color: #333;
    li {
      cursor: pointer;
      height: 28px;
      line-height: 28px;
      padding: 0 10px;
      &:hover {
        background-color: #f5f7fa;
        a {
          color: #333;
        }
      }
    }
  }
}
</style>
<style>
.communication .supFloat {
  height: 30px !important;
}
.tags-data {
  position: absolute;
  background: #ffffff;
  z-index: 10;
  border-radius: 2px;
}
.tags-data .title {
  overflow: hidden;
  background-color: #f5f7fa;
  line-height: 32px;
  font-weight: bold;
  padding: 0 12px;
}
.tags-data .title .name {
  float: left;
  width: 82px;
  margin-right: 9px;
  text-align: center;
  border-right: 1px solid #ddd;
}
.tags-data .title .content {
  float: left;
  width: calc(100% - 92px);
  text-align: center;
}
.tags-data .group {
  line-height: 24px;
  padding: 4px 12px;
  width: 800px;
  overflow: hidden;
}
.tags-data .group .name {
  float: left;
  width: 82px;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tags-data .group .content {
  float: left;
  width: calc(100% - 92px);
}

.el-cascader-panel.is-bordered {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/template/Next.vue